import { Guardian } from '.';

export class Lead {
	leadId: string;
	academicYearId: number;
	crmGuid: string;
	guardian: Guardian;
}
